import ModalView from "@modals/modalview/ModalView";
import styles from "./SendOtp.module.css";
import { useSelector } from "react-redux";
import { environment } from "@environments/environment";
import {
  readStoredPhoneCredentials,
  useSendOtp,
  useLoginModals,
} from "@hooks/login";

interface SendOtpProps {
  isOpen: boolean;
  onClose: () => void;
}

function SendOtp({ isOpen, onClose }: SendOtpProps) {
  const { goToVerifyOtp, goToPasswordLogin } = useLoginModals();

  const phoneData = readStoredPhoneCredentials();
  const phoneNumber = localStorage.getItem("phoneNumber");
  const countryCode = localStorage.getItem("countryCode");
  const displayNumber = `${countryCode}${phoneNumber}`;

  const isForgotPassword = useSelector(
    (state: { loginSessionData: { isForgotPassword: boolean } }) =>
      state.loginSessionData.isForgotPassword
  );

  const { error, requestOtp, isSending, captchaRef } = useSendOtp({
    phone: phoneData ?? { dialCode: "+91", number: "" },
    enabled: isOpen,
    onOtpSent: goToVerifyOtp,
  });

  if (!phoneData) {
    return null;
  }

  return (
    <>
      {isOpen && (
        <div
          ref={captchaRef}
          className="g-recaptcha"
          data-sitekey={environment.captchaSiteKey}
          data-size="invisible"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 9999,
          }}
        />
      )}

      <ModalView isOpen={isOpen} onClose={onClose}>
        <div className={styles.otpLoginContainer}>
          <div className={styles.otpHeader}>
            <h2>OTP Login</h2>
            <button className={styles.closeBtn} onClick={onClose}>
              &times;
            </button>
          </div>

          <p className={styles.otpSubText}>
            Please enter your registered phone number to get started
          </p>

          <input
            type="text"
            placeholder={displayNumber}
            className={styles.phoneInput}
            readOnly
          />

          {error && <p role="alert">{error}</p>}

          <button
            className={styles.sendOtpBtn}
            onClick={requestOtp}
            disabled={isSending}
          >
            SEND OTP
          </button>

          {!isForgotPassword && (
            <div
              className={styles.loginWithPassword}
              onClick={goToPasswordLogin}
            >
              LOGIN WITH PASSWORD
            </div>
          )}
        </div>
      </ModalView>
    </>
  );
}

export default SendOtp;
